'use strict';

/**
 * check if object has no keys
 */
function checkIsObjectEmpty(obj) {
    return (!obj ||
        (obj.constructor === String && obj.length === 0) ||
        (Array.isArray(obj) && obj.length === 0) ||
        (obj.constructor === Object && Object.keys(obj).length === 0));
}

exports.checkIsObjectEmpty = checkIsObjectEmpty;
//# sourceMappingURL=object.js.map
